﻿import React from 'react';

// components 
import PossessionsTable from './Desktop/PossessionsTable';
import PossessionsTableMobile from './Mobile/PossessionsTableMobile';

const PossessionsTableBase = (props) => {

    const [expanded, setExpanded] = React.useState(false);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [selected, setSelected] = React.useState("");
    const [selectedRowIndex, setSelectedRowIndex] = React.useState(null);

    const insuranceName = props.insuranceName;
    const content = props.content;
    const heading = content.heading;
    const mobile = props.mobile;

    React.useEffect(() => {
        content.levels.map((level, index) => {
            if (level.insuranceNames.find(name => name === insuranceName)) {
                setSelected(level.label);
                setSelectedRowIndex(index);
            }
        })
    }, []);

    return (
        <React.Fragment>

            {mobile === false &&
                <PossessionsTable  
                    content={content}
                    selected={selected}
                    heading={heading}
                    selectedRowIndex={selectedRowIndex}
                    expanded={expanded}
                    setExpanded={setExpanded}
                />}

               {mobile === true &&
                <PossessionsTableMobile
                    content={content}
                    selected={selected}
                    heading={heading}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />}

           </React.Fragment>
     )
};

export default PossessionsTableBase;

